export default __webpack_public_path__ + "static/media/resetPassword.259dad08.svg";